import { z } from "zod";

/**
 * An MCP tool's optional `annotations`. The protocol calls them HINTS and a server
 * can lie in them, so nothing may treat `readOnlyHint: true` as proof a tool is
 * safe. They are in the hashed contract because an admin approves a tool partly on
 * what they claim.
 */
export const McpToolAnnotationsSchema = z.looseObject({
  title: z.string().optional(),
  readOnlyHint: z.boolean().optional(),
  destructiveHint: z.boolean().optional(),
  idempotentHint: z.boolean().optional(),
  openWorldHint: z.boolean().optional()
});

export type McpToolAnnotations = z.infer<typeof McpToolAnnotationsSchema>;
